const Form050EN = {
    stepName: {
        statement: "Important Notes",
        application: "Application Details",
        confirmation: "Confirmation",
    },
    errorMsg: {
        date: {
            afterThisDate:
                "Please select a date after the First Day of Appointment",
        },
        needOne:
            "must fill either 'Name of Kindergarten' or 'Name of Child Care Centre'",
        amount: {
            min: "Please input a valid value",
            min1: "Value must be at greater than 1",
            max2: "Value must be at most 2 digits",
            max: "Value must be at most 3 digits",
            max4: "Value must be at most 4 digits",
            maxDecimal: "Value must be at most 3 decimal places",
        },
        sumTest: {
            yAndz: "Sum of Y and Z should above 0",
            velocity:
                "Sum of the values of point 1 to point 9 must be greater that 0",
            ventilationAir:
                "Sum of the values of minimum vent. required and Measured vent. air quality must be greater than 0",
            ventilationAir2:
                "Sum of this field and air quality should greater than 0",
            freshAir:
                "Sum of the values of minimum F.A. required and Measured F.A. quality must be greater than 0",
        },
    },
    label: {
        // from Form-50
        note1: "Standards for HVAC and Lighting for Child Care Centre",
        note2: "A. Air-conditioning System for Activity Areas",
        note3: "Design Criteria",

        note4_1: "(1) External conditions: Summer",
        note4_2: "33°C db",
        note4_3: "66% RH",
        note4_4: "Winter",
        note4_5: "10°C db",
        note4_6: "40% RH",

        note5_1: "(2) Internal conditions: Summer",
        note5_2: "25.5°C db",
        note5_3: "54% RH",
        note5_4: "Winter",
        note5_5: "20°C db",

        note6_1: "(3) Fresh air quantity:",
        note6_2:
            "10 litre/s/person. If room coolers or split type air conditioners are used, separate system of fresh air supply shall be provided to meet the said requirement.",
        note6_3: "10 litre/s/person.",
        note6_4:
            "If room coolers or split type air conditioners are used, separate system of fresh air supply shall be provided to meet the said requirement.",
        note5: "B. Noise level in Activity Areas",
        note6: "Noise level shall not exceed more than 4 dbA compared to the background noise.",

        note7: "C. Air-change rate for mechanical ventilation",
        note8_1: "Toilets:",
        note8_2: "15 air-change/hour",
        note8_3: "Kitchen:",
        note8_4:
            "15 air-change/hour (general extraction, not for kitchen exhaust hood)",
        note8_5: "Laundry:",
        note8_6: "15 air-change/hour",

        note9: "D. Lighting",
        note10: "Average illuminance of 300 lux at children’s working level, i.e. 0.5m above ground level to be maintained in the activity rooms.",

        note11: "Technical Information Checklist for Air-conditioning Installation in Child Care Centre",
        note12: "A. Design Stage",

        note12_1:
            "(1) Design drawing for air-conditioning and ventilation installations shall be submitted.",
        note12_2: "(2) Room name indicating the purpose of use shall be shown.",
        note12_3:
            "(3) Total number of occupants (including staff & children) in designated area and any other connected area not separated by solid wall shall be shown.",
        note12_4:
            "(4) Location and cooling capacity of each air-conditioning unit shall be indicated.",
        note12_5:
            "(5) Location mode of operation (intake or exhaust) of each ventilation fan shall be indicated.",
        note12_6:
            "(6) Fan size and air handling capacity (l/s) of each ventilation fan shall be shown.",
        note12_7:
            "(7) Fresh air supply quantity and air exchange rate calculations for each area normally occupied by children (e.g. classroom, activity room, children toilet, etc.) shall be provided to demonstrate compliance with the standards and requirements for child care centres.",
        note12_8:
            "(8) The fresh/exhaust air quantity at each air duct/louver/grille shall be shown.",
        note12_9:
            "(9) Provision shall be allowed in the fresh/exhaust air duct for measurement of air flow rate.",

        note13_1: "B. On Request for Inspection",
        note13_2:
            "Upon completion and testing of the whole installation, test report, calculation and as-fitted drawing with items A(1) to A(9) (where applicable) incorporated shall be submitted prior to the request for site inspection.",

        infoTitle: "Personal Information Collection Statement",
        info_1_header: "Purpose of Collection",
        info_1: "1.	The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        info_1_a:
            "(a)  Activities relating to the processing, authentication and counter-checking of the Ventilation Air Measurement Report/Fresh Air Measurement Report for CCC/Nursery;",
        info_1_b:
            "(b)  Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        info_1_c:
            "(c)  Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        info_1_d:
            "(d)  Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        info_1_e:
            "(e)  Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        info_1_f:
            "(f)  Activities relating to compilation of statistics, research and Government publications; and",
        info_1_g:
            "(g)  Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A))",
        info_2: "2.	The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        info_3_header: "Classes of Transferees",
        info_3: "3.	The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        info_3_a:
            "(a)  other Government bureau and departments, including Electrical and Mechanical Services Department, Fire Services Department and Building Department, for the purposes mentioned in paragraph 1 above;",
        info_3_b:
            "(b)  the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        info_3_c:
            "(c)  where you have given your prescribed consent to such disclosure; and",
        info_3_d:
            "(d)  where such disclosure is authorized or required under the law or court order applicable to Hong Kong.",
        info_4_header: "Access to Personal Data",
        info_4: "4. You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.",

        certify:
            "I have read, understood and agreed to the above terms and conditions.",

        iamStatement:
            'I understand the applicant need to have an "iAM Smart+" account to process the application.',

        // from Form-49
        note: "Important Notes",
        basicInfor: "幼稚園名稱",

        // from Form 50
        basicInfo: "Basic Information",
        agency: "Agency",
        address: "Address",
        attachment: "Attachment",
        attachmentLabel:
            "Please provided the original report signed by the contractor",

        location: "Location",
        type: "Type of assessment item",
        y: "Y (m)",
        x: "X (m)",
        z: "Z (m)",

        rmVolume: "Volume of Room (m<sup>3</sup>)",
        noOfPerson: "No. of Person of room",

        measureAirVelocity:
            "Measure Air Velocity at Check Point (see Fig.A) (m/s)",
        p1: "1",
        p2: "2",
        p3: "3",
        p4: "4",
        p5: "5",
        p6: "6",
        p7: "7",
        p8: "8",
        p9: "9",
        mean: "Mean Velocity",
        minVent: "Minimum Vent. Air Required at 15 air-change/hour (litre/s)",
        measuredVent: "Measured Vent. Air Quantity (litre/s)",
        minFresh: "Minimum F.A. Required at 10 l/s/p (litre/s)",
        measuredFresh: "Measured F.A. Quantity (litre/s)",

        ventTable: "Ventilation Air Measurement Table",
        freshAirTable: "Fresh Air Measurement Table",
    },
    noteValue: [
        {
            text: "「BEd(ECE)」:QKTs/CCWs with a bachelor degree in Early Childhood Education or equivalent ",
        },
        {
            text: "「C(ECE)」:QKTs/CCWs with a Certificate in Early Childhood Education or equivalent ",
        },
        { text: "「QKT」:Qualified Kindergarten Teachers" },
        { text: "「CCW」:Child Care Workers" },
        {
            text: "「Pursuing C(ECE)」:QKTs/CCWs or teaching staff with RT/valid PT No. pursuing a Certificate in Early Childhood Education or equivalent",
        },
    ],
    workingHoursValue: {
        "AM+PM": "AM+PM",
        AM: "AM",
        PM: "PM",
    },
    whetherValue: {
        Y: "Yes",
        N: "No",
    },
    qualificationValue: {
        "BEd(ECE)": "BEd(ECE)",
        "C(ECE)": "C(ECE)",
        QKT: "QKT",
        CCW: "CCW",
        "Pursuing C(ECE)": "Pursuing C(ECE)",
    },
    responsibleValue: {
        kg: "KG",
        ccc: "CCC",
    },
    tips: {
        tip1: "Sum of measured value(m/s) ÷ No. of check Point",
        tip2: "Volume of room(m<sup>3</sup>) x 15 + 3600 x 1000",
        tip3: "Mean velocity(m/s) x Y(m) x Z(m) x 1000 x Utilization Factor of the Louvre",
        tip2b: "No. of person x 10(1/s)",
    },
    demMultiTable: {
        field1: "Field 1",
        field2: "Field 2",
        field3: "Field 3",
        field4: "Field 4",
        field5: "Field 5",
        field6: "Field 6",
        field7: "Field 7",
        field8: "Field 8",
        field9: "Field 9",
    },
    enNote: {
        note1: "(1) External conditions:",
        note2: "Summer",
        note3: "(2) Internal conditions:",
        note4: "Winter",
    },
};
export default Form050EN;
